import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ readonly: boolean }>()((theme, { readonly = false }) => ({
  root: {
    justifyContent: 'space-between',
    height: theme.spacing(7.75),
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'row nowrap',
    flex: '0 0 auto',
    padding: theme.spacing(1.875, 0.75),
    cursor: readonly ? 'default' : 'pointer',

    '&:hover': {
      backgroundColor: readonly ? '' : theme.palette.secondary.main,
    },
  },

  avatar: {
    padding: theme.spacing(0, 1),
  },

  userName: {
    lineHeight: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    letterSpacing: '0.05em',
    fontFamily: '"Noto Sans"',
    fontSize: theme.spacing(1.75),
    textOverflow: 'ellipsis',
    maxWidth: theme.spacing(25),
  },
}));
